import '@ant-design/flowchart/dist/index.css';
import 'antd/dist/antd.css';
import BigNumber from 'bignumber.js';
import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'src/assets/scss/_themes.scss';
import 'src/assets/scss/variable.scss';
import Web3ActiveReactProvider from 'src/web3/components/Web3ActiveReactProvider';
import './App.scss';
import Layout from './components/01.layout';
import LocaleProviderComponent from './components/15.locale-provider';
import { AuthProvider } from './contexts/auth';
import ToastContext from './contexts/toast';
import Routes from './routes/Routes';
import { BaseSocket } from './socket/BaseSocket';
import initStore from './store';

BigNumber.config({
  ROUNDING_MODE: BigNumber.ROUND_DOWN,
  EXPONENTIAL_AT: [-50, 50],
});

const App: React.FC = () => {
  const { store } = initStore();

  useEffect(() => {
    BaseSocket.getInstance().connect();
  }, []);

  return (
    <Web3ActiveReactProvider>
      <Provider store={store}>
        <LocaleProviderComponent>
          <BrowserRouter basename="/exchange">
            <AuthProvider>
              <Layout>
                <ToastContext />
                <Routes />
              </Layout>
            </AuthProvider>
          </BrowserRouter>
        </LocaleProviderComponent>
      </Provider>
    </Web3ActiveReactProvider>
  );
};

export default App;
